import dedupeHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-header.png';
import dedupeSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-section1.png';
import dedupeSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-section2.png';
import dedupeSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_DEDUP: PageblockData = {
  headerData: {
    headerText: 'Simplify data management with automated deduplication',
    subHeaderText:
      'Eliminate duplicates and ensure your Salesforce data stays accurate and consistent.',
    imgSrc: dedupeHeader,
    imgAlt: 'Dedupe header',
    name: 'Dedupe & Matching',
  },
  pageTitle: 'Keep your data clean with deduplication and matching',
  section1: {
    imgSrc: dedupeSection1,
    imgAlt: 'Dedupe section img',
    title: 'Customize your deduplication logic',
    content:
      'Configure custom deduplication rules with advanced filters, tie-breakers, and timing control to support your data needs.',
  },
  section2: {
    imgSrc: dedupeSection2,
    imgAlt: 'Dedupe section 2 img',
    title: 'Auto-merge duplicates across Salesforce objects',
    content:
      'Automatically identify and merge duplicate records—such as leads, contacts, and accounts—across Salesforce objects, ensuring clean and consistent data.',
  },
  section3: {
    imgSrc: dedupeSection3,
    imgAlt: 'Dedupe section 3 img',
    title: 'Native matching for any Salesforce object',
    content:
      'No more manually matching leads to accounts. Automate this process and ensure new leads are accurately linked to existing accounts.',
  },
};
